import React, { useState } from 'react';
import { observer } from "mobx-react";
import { autorun } from 'mobx'
import { useHistory, useLocation } from "react-router-dom";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import LoadingSpinner from '../components/LoadingSpinner';
import {
  countiesWithStateStore,
  regionCountyListStore
} from '../store/apiStores'
import { nameFromUrl } from '../lib/strFormatting'

import './SelectLocation.css'


export default observer(function SelectLocation(props){
    let initialState = nameFromUrl(props.state)
    let initialCounty = nameFromUrl(props.county)
    console.log(`SelectLocation rendering - ${initialCounty}, ${initialState}`)

    let store = (props.useRegionCountyStore) ?
      (regionCountyListStore) : (countiesWithStateStore);

    // updates as selections are made in ui:
    const [selectedState, setSelectedState] = useState("");
    const [counties, setCounties] = useState(null);
    const [selectedCounty, setSelectedCounty] = useState("");


    let location = useLocation();
    React.useEffect(() => {
        console.log("SelectLocation - page location changed")
        setSelectedState(initialState || "")
        setSelectedCounty(initialCounty || "")
        //setCounties(null)
    }, [location]);


    // auto-select first state after setting states (will get called only once)
    React.useEffect(
      () =>
        autorun(() => {
          if (store.states && !props.useRegionCountyStore){
            setSelectedState(initialState || store.states[0])
          } else if (initialState) {
            console.log(`SelectLocation pre-selecting state ${initialState}`)
            setSelectedState(initialState)
            if (initialCounty) {
              console.log(`SelectLocation pre-selecting county ${initialCounty}`)
              setSelectedCounty(initialCounty)
            }
          }
        }),
      [], // note empty dependencies
    )

    // set counties to those of selected state
    React.useEffect(() => {
      console.log("SelectLocation - selectedState changed: " + selectedState)
      if (selectedState && store.data) {
        setCounties(store.counties(selectedState))
      } else {
        setCounties([])
      }
    }, [selectedState]);

    // set counties to those of selected state once data store loads
    // This covers situtation where the page is loaded and pre-selects
    // the state before the counties store has loaded
    React.useEffect(() => {
      if (selectedState && store.data) {
        setCounties(store.counties(selectedState))
      } else {
        setCounties([])
      }
    }, [store.data]);


    // auto-select '(state page)' or first county, depending on initialState, after setting counties
    React.useEffect(() => {
      console.log("counties changed")
      if (counties) {
        if (initialCounty && initialState == selectedState) {
          setSelectedCounty(initialCounty)
        } else {
          setSelectedCounty("");
        }
      }
    }, [counties]);


    let stateChanged = (e) => {
      e.preventDefault();
      setSelectedState(e.target.value)
    }

    let countyChanged = (e) => {
      e.preventDefault();
      setSelectedCounty(e.target.value)
    }

    const history = useHistory();
    let changeLocation = ((e) => {
      e.preventDefault();
      if (props.changeLocationHandler) {
        props.changeLocationHandler(selectedState, selectedCounty);
      } else {
        let query = window.location.search || '';
        if (selectedCounty == "") {
          history.push('/dashboard/' + selectedState.replace(/\s+/g, '-').toLowerCase() + query)
        } else {
          history.push('/dashboard/' + selectedState.replace(/\s+/g, '-').toLowerCase()
            + '/' + selectedCounty.replace(/\s+/g, '-').toLowerCase() + query)
        }
      }
    })

    let wrapperClassName = `select-location-wrapper ${props.small ? 'small' : 'large'}`
    let formSize = props.small ? "sm" : null;

    return (
      <div className={wrapperClassName}>
        <Form inline={true}>
          {props.header &&
            <div className="header d-none d-md-block">{props.header}</div>
          }
          <Form.Group size={formSize} controlId="select-state-control">
            <Form.Label>
              <span className="d-none d-md-block">
                {props.stateLabelPrefix || ''} State
              </span>
            </Form.Label>
            {(!store.states) ? (
              <LoadingSpinner />
            ) : (
              <Form.Control as="select" value={selectedState} onChange={stateChanged} custom>
                {props.unselectedStateOption && (
                  <option value="">({props.unselectedStateOption})</option>
                )}
                {store.states.map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </Form.Control>
            )}
          </Form.Group>
          <Form.Group size={formSize} controlId="select-county-control">
            <Form.Label><span className="d-none d-md-block">County</span></Form.Label>
            {(!counties && !props.showCountiesSelectWhenEmpty) ? (
              <LoadingSpinner />
            ) : (
              <Form.Control as="select" value={selectedCounty} onChange={countyChanged} custom>
                <option value="">({props.unselectedCountyOption || 'state page'})</option>
                {counties && counties.map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </Form.Control>
            )}
          </Form.Group>
          <Button size={formSize} variant="primary" type="submit" onClick={changeLocation}>
            {props.changeLocationButtonText || 'Go'}
          </Button>
        </Form>
      </div>
    )
})
